/* Actions */
import { ACTION_TYPES } from "./actions.js";

const initialState = {
  isOpen: false,
  headerImage: "",
  title: "",
  description: "",
  mainButtonText: "",
  mainButtonHref: "",
  openHrefInBlank: true,
  secondaryButtonText: "",
  showCloseIcon: false
};

export default function overScreenModal(state = initialState, { type, payload }) {
  switch (type) {
    case ACTION_TYPES.OPEN_OVER_SCREEN_MODAL:
      return { ...payload, isOpen: true };
    case ACTION_TYPES.CLOSE_OVER_SCREEN_MODAL:
      return initialState;
    default:
      return state;
  }
}
